export default __webpack_public_path__ + "static/inline-edit-do-c5e968fbc92ed7f8dc58bbe6784c5d92.png";